import * as React from 'react';
import { Grid } from "@mantine/core";
import { ISongStats } from "./types";
import axios from "axios";
import { IResponse } from "../../types/api";
import SongStatItem from "./SongStatsItem";

interface ISongStatItem {
    label: string;
    key: keyof ISongStats;
    color: string;
}

const statsDictionary: ISongStatItem[] = [
    { label: 'Дуунууд', key: 'totalCount', color: '#9AC5F4' },
    { label: 'Үндсэн дуу', key: 'generalCount', color: '#F79327' },
    { label: 'A-100', key: 'code1Count', color: '#9376E0' },
    { label: 'VIVAUS', key: 'vivaCount', color: '#47A992' },
    { label: 'Дууны үг', key: 'lyricCount', color: '#4F709C' },
    { label: 'Duul апп дээр', key: 'canPlayInDuul', color: '#9C27B0' },
    { label: 'Дуучдын зураг', key: 'image', color: '#E91E63' },
    { label: 'Зөвшөөрөл/NEXT', key: 'licenseNext', color: '#542AAC' },
    { label: 'Зөвшөөрөл/MCPP', key: 'licenseMCPP', color: '#542AAC' },
    { label: 'Зөвшөөрөл/MOSCAP', key: 'licenseMOSCAP', color: '#542AAC' },
    { label: 'Босоо бичиг', key: 'hasMLyrics', color: '#795548' },
    { label: 'Үг /Файл/', key: 'hasLyrics', color: '#795548' },
    { label: 'Дууны /Файл/', key: 'hasInstrumentFile', color: '#795548' },
    { label: 'Дуучинтай /Файл/', key: 'hasOriginalFile', color: '#795548' },
]



interface ISongStatsProps {
    controlled?: boolean;
    data?: ISongStats;
}

const SongStats = ({
    controlled = false,
    data
}: ISongStatsProps) => {

    const isLoadingRef = React.useRef(false);

    const [ stats, setStats ] = React.useState<ISongStats>({
        code1Count: null,
        generalCount: null,
        lyricCount: null,
        totalCount: null,
        vivaCount: null,
        canPlayInDuul: null,
        hasMLyrics: null,
        image: null,
        licenseNext: null,
        licenseMCPP: null,
        licenseMOSCAP: null,
        hasInstrumentFile: null,
        hasLyrics: null,
        hasOriginalFile: null,
    });

    React.useEffect(() => {
        if (!controlled) {
            const fetchSongStats = async () => {
                isLoadingRef.current = true;
                const { data } = await axios.post<IResponse<ISongStats>>(`/api/song/stats`);
                setStats(data.result);
                isLoadingRef.current = false;
            };
            void fetchSongStats();
        }
    }, []);

    return (
        <Grid gutter="xl" mb={'sm'}>
            {
                statsDictionary.map((statItem) => {
                    return (
                        <Grid.Col span={'content'} key={statItem.key}>
                            <SongStatItem
                                label={statItem.label}
                                value={controlled ? (data?.[statItem.key] ?? 0) : stats[statItem.key]}
                                color={statItem.color}
                                isLoading={isLoadingRef.current}
                            />
                        </Grid.Col>
                    )
                })
            }
        </Grid>
    )
};

export default SongStats;